<template>
  <div>
    <login-form-modal v-model="signInVisible"></login-form-modal>
    <!-- <base-modal ref="appointmentModals" v-if="appointmentModalVisible" v-model="appointmentModalVisible">
      <b-row class="card-modal">
        <b-col cols="12" md="6">
          <neu-card-function class="card"
            src="/static-appopensalud/img/icons/morillas-svg-icons/primary/insurance-appointment.svg"
            :title="$t('unipromel.insurance-appointments')" :subtitle="$t('unipromel.insurance-appointments-subtitle')">
          </neu-card-function>
        </b-col>
        <b-col cols="12" md="6">
          <neu-card-function class="card"
            src="/static-appopensalud/img/icons/morillas-svg-icons/primary/private-appointment.svg"
            :title="$t('unipromel.private-appointments')" :subtitle="$t('unipromel.insurance-appointments-subtitle')">
          </neu-card-function>
        </b-col>
      </b-row>
    </base-modal> -->
    <b-navbar class="navbar" toggleable="lg">
      <b-navbar-brand href="/"><img class="navbar-brand-img" :src="getLogo" /></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item class="my-auto" @click="$helpers.goToSection('block-patients')">{{ $t('unipromel.patients')}}</b-nav-item>
          <b-nav-item class="my-auto" href="https://unipromel.es">Unipromel</b-nav-item>
          <!-- <b-nav-item class="my-auto nav-lang">
            <lang-selector class="d-inline-block pt-lg-0 pt-3 pb-lg-0 pb-2 mr-0"></lang-selector>
          </b-nav-item>  -->
          <span style="display: contents">
            <b-nav-item>
              <base-button blue outline @click="() => { signUpVisible = true }"><span>{{ $t('sign-up') }}</span>
              </base-button>
            </b-nav-item>
            <b-nav-item>
              <base-button blue @click="() => { signInVisible = true }"><span>{{ $t('log-in') }}</span>
                <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2"
                  :color="$uiHelpers.isMobile ? BLUE_UNIPROMEL_COLOUR : 'white'" />
              </base-button>
            </b-nav-item>
          </span>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="landing-cnt row">
      <div class="bg-image"></div>
      <div class="col-12 d-xl-none d-lg-flex main-block-xs"></div>
      <div class="text-block-ctn col-xl-6 col-12 d-flex my-auto">
        <div class="text-ctn my-auto">
          <h3>{{ $t('unipromel.title') }}</h3>
          <h1 v-html="$t('unipromel.subtitle')"></h1>
          <p class="mt-2 mt-md-4">{{ $t('unipromel.paragraph') }}</p>
          <div class="btn-cnt mt-5">
            <base-button class="btn-landing-pat mt-4 mt-md-0 mb-4" white shadow @click="openPrivateAppointments">
              {{ $t('unipromel.private-appointments') }} (*)</base-button>
            <base-button class="btn-landing-pat mt-4 mt-md-0 mb-4" gray outline @click="openInsuranceAppointment">{{ $t('unipromel.insurance-appointments') }}</base-button>
            <div class="mt-4">
              <span class="xs-text text-primary" style="font-size: 0.85rem; cursor: pointer;">*{{ $t('unipromel.more-information') }}</span>
            </div>
          </div>
          <landing-search-selectors v-if="searchVisible" :showInsurances="showInsurances" :services="getAvailableServices"></landing-search-selectors>
        </div>
      </div>
      <div class="learn-more" @click="$helpers.goToSection('become-partner')">
        <span>{{ $t('unipromel.learn-more') }}</span>
      </div>
    </div>

    <neu-cards-slider2  :cards="cards" :blackTitle="$t('unipromel.block-2.blackTitle')"
      :title="$t('unipromel.block-2.title')" :iconsColor="BLUE_UNIPROMEL_COLOUR" ></neu-cards-slider2>
    
    <!-- <neu-cards-slider-pricing class="section py-lg-5 py-0" :cards="cardPrivateAppointment" :cards2="cardInsuranceAppointment">
      <template v-slot:conditions>
        <span>(*) {{ $t('abogalitypro.subscriptions.law-firm-text') }}</span><br>
        <span>(**) {{ $t('abogalitypro.subscriptions.price-text') }}</span>
      </template>
    </neu-cards-slider-pricing> -->

    <b-row id="block-patients" class="section-invert reverse-sm">
        <b-col md="12" lg="6" style="text-align:center" class="content my-auto">
          <h3>{{ $t('unipromel.block-patients.title') }}</h3>
          <div class="subtitle">
            <div class="subtitle-list subtitle-list-large mt-sm-5">
              <b-row>
                <b-col style="margin-bottom:5%" cols="12">
                  <span style="font-size:1.35rem">
                    {{ $t('unipromel.block-patients.subtitle') }}
                  </span>
                </b-col>
              </b-row>
            </div>
              <base-button class="btn-end" white outline @click="() => { signUpVisible = true }"><span>{{ $t('unipromel.block-patients.access-btn') }}</span></base-button>
          </div>
        </b-col>
        <b-col md="12" lg="6" class="py-sm-0">
          <div class="col-bg ml-lg-auto">
          </div>
        </b-col>
      </b-row>

    <b-row id="become-partner" class="section py-lg-5 py-0 my-lg-5 my-0 reverse-sm">
        <b-col md="12" lg="6" class="my-auto content">
          <h3>{{ $t('unipromel.medics-together') }}</h3>
          <h3>{{ $t('unipromel.free-professionals') }}</h3>
          <p class="mt-5 w-75" style="font-size:1.35rem">{{ $t('unipromel.text') }}</p>
          <br>
          <base-button href="https://unipromel.es/asociarse/" outline shadow class="mt-5">{{ $t('unipromel.become-partner') }}</base-button>
        </b-col>
        <b-col md="12" lg="6" class="py-5 py-lg-5">
          <div class="col-bg ml-lg-auto"> 
          </div>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import LangSelector from '@/components/base/LangSelector'
import NeuCardsSlider from '@/components/base/ui/NeuCardsSlider'
import CompaniesContactForm from '@/components/forms/CompaniesContactForm.vue'
import Footer360 from '@/components/public/footers/Footer360.vue'
import LoginForm from '@/components/forms/LoginForm.vue'
import BaseModal from '@/components/base/BaseModal.vue'
import { BLUE_UNIPROMEL_COLOUR } from '@/constants/colours'
import NeuCardsSlider2 from '../../base/ui/NeuCardsSlider2.vue'
import NeuCardFunction from '@/components/base/ui/NeuCardFunctions.vue'
import layoutMixin from '@/mixins/layout.mixin'
import LoginFormModal from '@/components/base/modals/LoginFormModal'
import LandingSearchSelectors from '@/components/public/LandingSearchSelectors.vue'
/* import NeuCardsSliderPricing from '@/components/base/ui/NeuCardsSliderPricing.vue' */

const CONSULTATION_TYPES_OPTIONS = [
  {
    value: 'insurance-preferent',
    label: 'Consulta seguro preferente'
  },
  {
    value: 'online',
    label: 'Consultas online'
  },
  {
    value: 'subscriptions',
    label: 'Subscripciones'
  },
  {
    value: 'others',
    label: 'Otros servicios'
  }
]

export default {
  name: 'unipromel',
  components: {
    'sign-up': () => import('@/components/views/SignUp'),
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BNavItem,
    BCollapse,
    LangSelector,
    NeuCardsSlider,
    CompaniesContactForm,
    Footer360,
    BaseModal,
    LoginForm,
    NeuCardsSlider2,
    NeuCardFunction,
    LoginFormModal,
    LandingSearchSelectors
    /* NeuCardsSliderPricing */
  },
  mixins: [
    layoutMixin
  ],
  data () {
    return {
      BLUE_UNIPROMEL_COLOUR,
      appointmentModalVisible: false,
      showInsurances: false,
      hover: false,
      signInVisible: false,
      signUpVisible: false,
      cards: [
        {
          title: this.$t('unipromel.card.title1'),
          subtitle: this.$t('unipromel.card.subtitle1'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_VIDEOCONSULTA_AZUL.svg',
          type: 0
        },
/*         {
          title: this.$t('unipromel.card.title2'),
          subtitle: this.$t('unipromel.card.subtitle2'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png',
          type: 0
        }, */
        {
          title: this.$t('unipromel.card.title3'),
          subtitle: this.$t('unipromel.card.subtitle3'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_HISTORIAL_CLINICO.svg',
          type: 0
        },
        {
          title: this.$t('unipromel.card.title4'),
          subtitle: this.$t('unipromel.card.subtitle4'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_CONSULTA_CASA.svg',
          type: 0
        },
        {
          title: this.$t('unipromel.card.title5'),
          subtitle: this.$t('unipromel.card.subtitle5'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PACKS.svg',
          type: 0
        },
        {
          title: this.$t('unipromel.card.title6'),
          subtitle: this.$t('unipromel.card.subtitle6'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_CALENDARIO.svg',
          type: 0
        },
        {
          title: this.$t('unipromel.card.title7'),
          subtitle: this.$t('unipromel.card.subtitle7'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_OPENSALUD_PASS.svg',
          type: 0
        },
         {
          title: this.$t('unipromel.card.title8'),
          subtitle: this.$t('unipromel.card.subtitle8'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_TELE_MONITORIZACIÓN.svg',
          type: 0
        },
         {
          title: this.$t('unipromel.card.title9'),
          subtitle: this.$t('unipromel.card.subtitle9'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PRECIO.svg',
          type: 0
        }
      ],
      searchVisible: false,
      searchForm: {
        specialty: null,
        appointmentType: null
      },
      specialties: [],
      appointmentTypes: []
    }
  },
  methods: {
    showAppointmentModal () {
      this.appointmentModalVisible = true
    },
    openPrivateAppointments () {
      this.searchVisible = !this.searchVisible
      this.showInsurances = false
    },
    openInsuranceAppointment () {
      this.searchVisible = !this.searchVisible
      this.showInsurances = !this.showInsurances
    }
  },
  computed: {
    getAvailableServices () {
      let availableServices = []
      if (this.showInsurances) {
        availableServices.push({
          value: 'insurances',
          label: 'Consultas aseguradoras'
        })
      } else {
        availableServices.push({
          value: 'private',
          label: 'Sólo consultas privadas'
        })
      }
      return CONSULTATION_TYPES_OPTIONS
    }
  }
}
</script>

<style scoped lang="scss">
@import "static-appopensalud/css/public/views/unipromel.scss";

/deep/ {
  #become-partner {
    .col-bg {
      background-image: url('/static-appopensalud/img/bgs/unipromel-bg-asset.png');
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  .landing-cnt {
    h1 {
      font-size: 3.2rem;
    }

    h4 {
      @include mobile {
        font-size: 1rem;
      }
    }

    .btn-cnt {
      @include mobile {
        margin-top: 2rem !important;
      }
    }
  }

 .card-modal {
    .card {
      border-width: 0px !important;
    }

    .neu-card {
      min-height: 450px;
      border-width: 0px !important;
    }
  }

  .nav-link {
    color: $blue !important;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }

  .btn-cnt {
    margin-bottom: 0;
  }

  .section-invert .subtitle {
    margin-top: 1rem;
    width: 100% !important;

    button span {
      color: white;
      &:hover {
        color: $black;
      }
    }
  }

  #block-patients {
    .col-bg {
      background-image: url('/static-appopensalud/img/bgs/opt/image21.jpg'),  linear-gradient(
      180deg, #E4E4E455, #E4E4E4ff);
      background-position-x: center;
    }
  }
  
  .neu-card-ctn .subtitle p {
    color: $blue !important;
  }

}

</style>


// WEBPACK FOOTER //
// src/components/views/unipromel/Unipromel.vue